<template>
    <div>
        <div>
            <div>
                <div class="catalog-title" style="font-weight: bold">项目分类</div>
                <div class="catalog-title" :class="{ 'catalog-title-active': item.isActive }"
                     v-for="(item, index) in classifyList" :key="index"
                     @click="clickClassifyItem(item, index)">{{ item.name }}
                </div>
            </div>
            <div style="margin-top: 10px">
                <div class="select-materials-label">
                    <span>项目名称：</span>
                </div>
                <div class="select-materials-input">
                    <Input v-model="itemParam.name"/>
                </div>
                <div class="form-button">
                    <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQueryItem">查询</Button>
                </div>
            </div>
            <Row style="margin-top: 10px">
                <Col span="14" style="padding-right: 40px">
                    <Table border ref="selectionTable" size="small" :columns="itemColumn"
                           :data="itemList"
                           :loading="itemLoading"
                           @on-row-click="clickShowItemTable">
                    </Table>
                    <div style="margin-top: 10px;text-align: left">
                        <Page v-model="itemParam.current" :page-size="itemParam.size"
                              :total="itemParam.total"
                              @on-change="onMaterialsPageChange"
                              @on-page-size-change="onMaterialsPageSizeChange"
                              show-sizer show-elevator show-total/>
                    </div>
                </Col>
                <Col span="10">
                    <Table border ref="selectionTable" size="small" :columns="selectedColumn"
                           :data="selectedItemList">
                        <template #action="{ row, index }">
                            <Button class="table-button-remove" size="small"
                                    @click="removeSelected(row)">删除
                            </Button>
                        </template>
                        <template #count="{ row, index }">
                            <Input type="number" v-model="row.count" @on-blur="onCountBlur(row)"
                                   @on-keydown="onCountInputKeyPress"></Input>
                        </template>
                    </Table>
                </Col>
            </Row>
        </div>
        <div style="text-align: right;margin-top: 10px">
            <Button style="margin-right: 10px" type="primary" @click="selectMaterOk" icon="md-checkmark">确定</Button>
            <Button @click="selectMaterCancel" icon="ios-undo">取消</Button>
        </div>
    </div>
</template>

<script>
import {queryItemClassifyList, queryItemInfoPage} from "@/api/baseData"

export default {
    name: "ChooseItem",
    data() {
        return {
            classifyList: [],
            itemParam: {
                name: '',
                classifyIds: [],
                total: 0,
                current: 1,
                size: 10,
            },
            itemColumn: [
                {
                    title: '项目代码',
                    key: 'code',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '项目名称',
                    key: 'name',
                    align: 'left',
                },
                {
                    title: '计价方式',
                    key: 'priceMethod',
                    align: 'center',
                    render: this.renderPriceMethod,
                    width: 120,
                },
                {
                    title: '工时',
                    key: 'preManhour',
                    align: 'center',
                    width: 80,
                },
                {
                    title: '单价',
                    key: 'unitPrice',
                    align: 'center',
                    width: 80,
                },
                {
                    title: '项目金额',
                    key: 'totalPrice',
                    align: 'center',
                    width: 120,
                },
            ],
            selectedColumn: [
                {
                    title: '项目名称',
                    key: 'name',
                    align: 'left',
                },
                {
                    title: '数量',
                    slot: 'count',
                    width: 120,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 80,
                    align: 'center',
                },
            ],
            itemList: [],
            itemLoading: false,
            selectedItemList: [],
        }
    },
    mounted() {
        this.onQueryItem()
        queryItemClassifyList({}).then((res) => {
            this.classifyList = res.data
            const item = {id: 0, name: '全部'}
            this.classifyList.unshift(item)
        })
    },
    methods: {
        onQueryItem() {
            if (this.itemLoading) {
                return
            }
            this.itemLoading = true
            queryItemInfoPage(this.itemParam).then((res) => {
                this.itemList = res.data
                this.itemParam.current = res.current
                this.itemParam.total = res.total
            }).finally(() => {
                this.itemLoading = false
            })
        },
        clickClassifyItem(item, index) {
            if (item.id === 0) {
                if (!item.isActive) {
                    for (let i = 0; i < this.classifyList.length; i++) {
                        this.$set(this.classifyList, i, {
                            ...this.classifyList[i],
                            isActive: true,
                        })
                    }
                } else {
                    for (let i = 0; i < this.classifyList.length; i++) {
                        if (i === 0) {
                            this.$set(this.classifyList, i, {
                                ...this.classifyList[i],
                                isActive: true,
                            })
                        } else {
                            this.$set(this.classifyList, i, {
                                ...this.classifyList[i],
                                isActive: false,
                            })
                        }
                    }
                }
            } else {
                this.$set(this.classifyList, index, {
                    ...item,
                    isActive: !item.isActive,
                })
                let hasNotActive = false
                for (let i = 1; i < this.classifyList.length; i++) {
                    if (!this.classifyList[i].isActive) {
                        hasNotActive = true
                    }
                }
                if (hasNotActive) {
                    this.$set(this.classifyList, 0, {
                        ...this.classifyList[0],
                        isActive: false,
                    })
                } else {
                    this.$set(this.classifyList, 0, {
                        ...this.classifyList[0],
                        isActive: true,
                    })
                }
            }
            this.itemParam.classifyIds = []
            for (let i = 0; i < this.classifyList.length; i++) {
                if (this.classifyList[i].isActive) {
                    this.itemParam.classifyIds.push(this.classifyList[i].id)
                }
            }
            this.onQueryItem()
        },
        clickShowItemTable(row) {
            if (this.isExist(this.selectedItemList, row)) {
                return
            }
            let sel = Object.assign({}, row)
            sel.count = 1
            this.selectedItemList.push(sel)
        },
        isExist(list, data) {
            for (let item of list) {
                if (item.id === data.id) {
                    return true
                }
            }
            return false
        },
        onMaterialsPageChange(e) {
            this.itemParam.current = e
            this.onQueryItem()
        },
        onMaterialsPageSizeChange(e) {
            this.itemParam.current = 1
            this.itemParam.size = e
            this.onQueryItem()
        },
        selectMaterOk() {
            this.$emit('handleClose', this.selectedItemList)
        },
        selectMaterCancel() {
            this.$emit('handleClose', false)
        },
        renderPriceMethod(h, param) {
            let id = param.row.priceMethod
            if (id === 1) {
                return h('span', '工时计价')
            }
            return h('span', '金额计价')
        },
        removeSelected(row) {
            for (let i = 0; i < this.selectedItemList.length; i++) {
                if (this.selectedItemList[i].id === row.id) {
                    this.selectedItemList.splice(i, 1)
                    return
                }
            }
        },
        onCountBlur(row) {
            for (let i = 0; i < this.selectedItemList.length; i++) {
                if (this.selectedItemList[i].id === row.id) {
                    this.selectedItemList[i].count = row.count
                    return
                }
            }
        },
        onCountInputKeyPress(event) {
            if (event.key !== 'Backspace' && !/[0-9]/.test(event.key)) {
                event.preventDefault()
            }
        },
    },
}
</script>

<style scoped>
.catalog-title {
    display: inline-block;
    margin-right: 2px;
    cursor: pointer;
    padding: 2px 6px;
}

.catalog-title-active {
    background: #73cee8;
    color: #ffffff;
}

.select-materials-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 5px;
}

.select-materials-input {
    display: inline-block;
    width: 200px;
    font-size: 14px;
    margin-right: 15px;
}

.form-button {
    display: inline-block;
}
</style>
